import $ from 'jquery';
import { PubsubReplay } from 'pubsub-replay';

if (!window.ipEventBus) {
	window.ipEventBus = PubsubReplay;
}
const VALIDATE_CRITERIA_COUNT = 3;

// todo ezek cseréje
const LOGIN_CALLBACK_URL = window.location.origin + '/login';
const REGISTRATION_CALLBACK_URL = window.location.origin + '/callback';

export class LoginService {
	constructor($http, $mdDialog, UserHandlerService, CommonConstants, $rootScope, $cookies, loaderService, notificationService) {
		'ngInject';
		this.$http = $http;
		this.$mdDialog = $mdDialog;
		this.userHandlerService = UserHandlerService;
		this.commonConstants = CommonConstants;
		this.$rootScope = $rootScope;
		this.$cookies = $cookies;
		this.loader = loaderService;
		this.notificationService = notificationService;
		this.messages = {};
		this.unregistered = {};
		this.login = {};
		this.showPw = {};
	}

	openLoginForm(event) {
		this.closePopup();
		this.setMouseUpEvent('login_password');
		event.preventDefault && event.preventDefault();
		this.$mdDialog.show({
			templateUrl: 'login-form-popup.html',
			clickOutsideToClose: true,
			controller: () => this,
			controllerAs: '$ctrl',
			multiple: true
		});
	}

	openRegistrationForm() {
		this.closePopup();
		this.setMouseUpEvent('reg_password');
		this.$mdDialog.show({
			templateUrl: 'registration-form-popup.html',
			clickOutsideToClose: true,
			controller: () => this,
			controllerAs: '$ctrl'
		});
	}

	openForgottenPwModal(event) {
		this.$mdDialog.hide();
		event.preventDefault();
		this.$mdDialog.show({
			templateUrl: 'forgotten-password-popup.html',
			clickOutsideToClose: true,
			controller: () => this,
			controllerAs: '$ctrl',
			multiple: true
		});
	}

	submitLoginForm(regParams) {
		this.loader.show();
		let params = {};
		if (!regParams) {
			params = {
				callback: LOGIN_CALLBACK_URL,
				email: this.login.email,
				password: this.login.password
			};
		} else {
			params = {
				callback: LOGIN_CALLBACK_URL,
				email: regParams.email,
				password: regParams.password
			};
		}
		this.userHandlerService.login(params).then(
			() => {
				this.loader.hide();
				window.dataLayer.push({
					event: 'loginSuccess'
				});
				let cookieValue = regParams ? 'loginSuccessRegistrationSuccess' : 'loginSuccess';
				this.$cookies.put('login', cookieValue, { path: '/' });
				this.$cookies.put('hello', true, { path: '/' });
				window.location.reload();
			},
			error => {
				this.loader.hide(0);
				this.loginError = error.data ? error.data.error : 'technicalError';
			}
		);
	}

	submitRegistrationForm() {
		this.registrationForm.email.$setValidity('alreadyExists', true);
		this.loader.show();
		let params = {
			email: this.unregistered.email,
			password: this.unregistered.password,
			name: this.unregistered.lastName + ' ' + this.unregistered.firstName,
			callback: REGISTRATION_CALLBACK_URL,
			marketing: !!this.unregistered.marketing
		};
		this.userHandlerService.registration(params).then(
			() => {
				this.closePopup();
				window.dataLayer.push({
					event: 'registrationSuccess'
				});
				this.submitLoginForm(params);
			},
			error => {
				if (error) {
					this.loader.hide(0);
					if (error.data && error.data.error && error.data.error == 'alreadyExists') {
						this.registrationForm.email.$setValidity('alreadyExists', false);
					} else {
						this.closePopup();
						window.ipEventBus.publish('show-error', {
							message: error.data ? error.data.status : 'technicalError'
						});
						this.notificationService.showError({
							message: error.data ? error.data.error : 'technicalError'
						});
					}
				}
			}
		);
	}

	logout() {
		this.loader.show();
		this.userHandlerService.logout().then(
			response => {
				this.$rootScope.isLoggedIn = false;
				this.$cookies.remove('sawSoldFavourites');
				this.$cookies.remove('hello');
				this.$cookies.remove('seenHello');
				this.$cookies.put('logout', 'success', { path: '/' });
				this.loader.hide();
				window.location.href = '/';
			},
			error => {
				this.loader.hide();
				console.log('logout error', error);
				window.location.href = '/';
			}
		);
	}

	submitForgotPassword() {
		this.loader.show();
		let params = {
			callback: window.location.origin + '/callback',
			email: this.forgetPw.email
		};
		this.userHandlerService
			.forgotPassword(params)
			.then(() => {
				this.loader.hide(0);
				this.closePopup();
				this.messages.forgotPwResponse = 'forgotPasswordSuccess';
				window.ipEventBus.publish('show-info', {
					message: 'forgotPasswordSuccess'
				});
				this.notificationService.showInfo({
					message: 'forgotPasswordSuccess'
				});
			})
			.catch(error => {
				this.loader.hide(0);
				this.closePopup();
				window.ipEventBus.publish('show-error', {
					message: error.data ? error.data.status : 'technicalError'
				});
				this.notificationService.showError({
					message: error.data ? error.data.status : 'technicalError'
				});
			});
	}

	setFieldVisible(id) {
		$('#' + id).attr('type', 'text');
	}

	toggleFieldVisible(id) {
		if (!this.showPw[id]) {
			$('#' + id).attr('type', 'text');
		} else {
			$('#' + id).attr('type', 'password');
		}
		this.showPw[id] = !this.showPw[id];
	}

	setMouseUpEvent(id) {
		$(document).on('mouseup', () => {
			$('#' + id).attr('type', 'password');
		});
	}

	validatePw(model, modelName, formName) {
		if (this[model][modelName]) {
			if (this[model][modelName].length >= 15) {
				this[formName][modelName].$setValidity('criteria', true);
			} else {
				let countOfCriteria = 0;
				if (/[\! "#\$%&'\(\)\*\+,-\.\/:;<=>\?@\[\]\^_`{\|}~]/.test(this[model][modelName])) {
					countOfCriteria++;
				}
				if (/[a-z]/.test(this[model][modelName])) {
					countOfCriteria++;
				}
				if (/[A-Z]/.test(this[model][modelName])) {
					countOfCriteria++;
				}
				if (/[0-9]/.test(this[model][modelName])) {
					countOfCriteria++;
				}
				let isValid = countOfCriteria >= VALIDATE_CRITERIA_COUNT;
				this[formName][modelName].$setValidity('criteria', isValid);
			}
		}
	}

	closePopup(action, label) {
		this.$mdDialog.cancel();
		this.messages = {};
		this.loginError = false;
	}
}
